<template>
	<transition name="modal">
		<div class="modal">
			<div class="modal_overlay" @click="$emit('close')"></div>
			<div class="modal__wrapper">
				<div class="modal__container">
					<div class="modal__body">
						<slot></slot>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	data() {
		return {
			showX: true
		}
	},
	methods: {}
}
</script>

<style scoped>
.modal {
	z-index: 10;
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
}
.modal_overlay {
	background: rgba(1, 1, 1, 1);
	opacity: 0.5;
	position: absolute;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
}
.modal__wrapper {
	position: relative;
	width: 65vmin;
	min-height: 35vmin;
	background: #fff;
	color: #333;
	display: flex;
	border-radius: 0.2em;
	box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.2), 0 1em 2em -1em;
}
.modal__container {
	flex: 1;
	display: flex;
	flex-direction: column;
}

.modal-enter-active,
.modal-leave-active {
	transition: opacity 0.5s;
}
.modal-enter,
.modal-leave-to {
	opacity: 0;
}
</style>
